import { render, staticRenderFns } from "./BulkTransferComponent.vue?vue&type=template&id=a9689970"
import script from "./BulkTransferComponent.vue?vue&type=script&lang=js"
export * from "./BulkTransferComponent.vue?vue&type=script&lang=js"
import style0 from "./BulkTransferComponent.vue?vue&type=style&index=0&id=a9689970&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports